export const PRICE_LINE_TYPES = {
  BILL: 'bill',
  INCLUDED: 'included',
  DISCOUNT: 'discount'
};
